import { useMutation, useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/constants';
import { LoginWithUserNamePasswordPayload, OTPLoginPayload } from '@/features/logins/interfaces';
import { LoginService } from '@/features/logins/services';

export const useLoginWithUserNamePassword = () => {
  return useMutation({
    mutationFn: async (payload: LoginWithUserNamePasswordPayload) =>
      await LoginService.LoginWithUserNamePassword(payload),
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: async () => await LoginService.Logout(),
  });
};

export const useSendOTP = () => {
  return useMutation({
    mutationFn: async (email: string) => await LoginService.SendOTP(email),
  });
};

export const useResendOTP = () => {
  return useMutation({
    mutationFn: async (email: string) => await LoginService.ResendOTP(email),
  });
};

export const useVerifyOTP = () => {
  return useMutation({
    mutationFn: async (payload: OTPLoginPayload) => await LoginService.VerifyOTP(payload),
  });
};

export const useCurrentProfile = () => {
  return useQuery({
    queryKey: QUERY_KEYS.currentProfile,
    queryFn: () => LoginService.GetCurrentProfile(),
  });
};
